<ng-container *sm-has-env-flag="'auroraV1'">
    @if (options?.length == 1) {
        <aurora-icon-button
            variant="ghost"
            size="xlarge"
            icon="help"
            label="Insurity Knowledge Center"
            (click)="clickOption(options[0])">
        </aurora-icon-button>
    } @else {
        <div class="ikc-menu-dropdown" (click)="$event.stopPropagation()">
            <aurora-icon-button
                variant="ghost"
                size="xlarge"
                icon="help"
                label="Insurity Knowledge Center"
                (click)="toggleAuroraMenu($event)">
            </aurora-icon-button>

            @if (isIkcMenuOpen) {
            <div class="ikc-menu-dropdown-panel">
                <aurora-menu
                    aurora-light
                    [items]="auroraMenuItems"
                    [showFilter]="false"
                    [showEmptyState]="false"
                    (item-click)="onAuroraMenuItemClick($event)">
                </aurora-menu>
            </div>
            }
        </div>
    }
</ng-container>

<ng-container *sm-has-not-env-flag="'auroraV1'">
    @if (options?.length == 1) {
        <button unity-button class="icon-only on_dark"
            title="Insurity Knowledge Center"
            (onClick)="clickOption(options[0])">
            <unity-icon icon="help" size="xlarge" />
        </button>
    } @else {
        <ng-template #templateContent>
            <div>
                <h4>Insurity Knowledge Center</h4>
                @for (option of options; track option.Product) {
                    <div class="option-row">
                        @if (option.Product == 'Bureau Rating') {
                            <img src="assets/surecomm.svg" alt="Bureau Rating icon" />
                            <button unity-button class="ms-2 link" (onClick)="clickOption(option)">Bureau Rating</button>
                        }
                        @if (option.Product == 'Underwriting') {
                            <img src="assets/favicon.ico" alt="Underwriting icon" />
                            <button unity-button class="ms-2 link" (onClick)="clickOption(option)">Underwriting</button>
                        }
                    </div>
                }
            </div>
        </ng-template>
        <button unity-button
                class="icon-only on_dark"
                [ngbPopover]="templateContent"
                [autoClose]="'outside'"
                placement="bottom"
                title="Insurity Knowledge Center"
                container="body"
                tabindex="0"
                [popoverClass]="">
            <unity-icon icon="help" size="xlarge" />
        </button>
    }
</ng-container>
